import { createQueryKeys } from '@lukemorales/query-key-factory';
import { EQueryKeys } from 'common/enums/query-kyes.enum';
import {
  reconciliationGetCounterpartyListService,
  reconciliationGetCounterpartyParticipantsService,
  reconciliationGetParticipantsService,
} from '../services/reconciliation.service';
import {
  IReconciliationGetReconciliationsResponse,
  TReconciliationCounterpartyListReqParams,
  TReconciliationCounterpartyParticipantsListReqParams,
  TReconciliationParticipantsListReqParams,
  IReconciliationGetParticipantsResponse,
} from '../types/reconciliation.types';

export const reconciliationQueryKeys = createQueryKeys(EQueryKeys.ReconciliationQueryKeys, {
  getParticipants: (params: TReconciliationParticipantsListReqParams) => ({
    queryKey: ['reconciliation', 'participants', params],
    queryFn: (): Promise<IReconciliationGetParticipantsResponse> => reconciliationGetParticipantsService(params),
  }),
  getCounterpartyParticipants: (
    counterpartyGUID: string,
    params: TReconciliationCounterpartyParticipantsListReqParams,
  ) => ({
    queryKey: ['reconciliation', 'participants', counterpartyGUID, params],
    queryFn: (): Promise<IReconciliationGetParticipantsResponse> =>
      reconciliationGetCounterpartyParticipantsService(counterpartyGUID, params),
  }),
  getCounterpartyList: (
    debtorGUID: string,
    creditorGUID: string,
    params: TReconciliationCounterpartyListReqParams,
  ) => ({
    queryKey: ['reconciliation', 'recons-list', debtorGUID, creditorGUID, params],
    queryFn: (): Promise<IReconciliationGetReconciliationsResponse> =>
      reconciliationGetCounterpartyListService(debtorGUID, creditorGUID, params),
  }),
  getCounterpartyDetails: (
    debtorGUID: string,
    creditorGUID: string,
    params: TReconciliationCounterpartyListReqParams,
  ) => ({
    queryKey: ['reconciliation', 'recons-details', debtorGUID, creditorGUID, params],
    queryFn: (): Promise<IReconciliationGetReconciliationsResponse> =>
      reconciliationGetCounterpartyListService(debtorGUID, creditorGUID, params),
  }),
});
